// extracted by mini-css-extract-plugin
export default {"contentContainer":"Documentation_contentContainer__-D9Hp","linkContainer":"Documentation_linkContainer__7os0-","innerContainer":"Documentation_innerContainer__w9cNX"};